let currentStep = 1;
const quizDemo = document.getElementById("quiz-demo");
const prevBtn = document.getElementById("prevBtn");
const nextBtn = document.getElementById("nextBtn");
const finelBtn = document.getElementById("finelBtn");
const progressBar = document.getElementById("progress");
const productCard = document.querySelector(".product-innercarddetails");

const points = {
  "The Audrey Rose Letters": 0,
  "The Lily Clara Letters": 0,
  "The Adelaide Magnoila Letters": 0,
  "The Norah Aven Chronicles": 0,
  "The Orchid Mae Letters": 0,
};

const productLinks = {
  "The Audrey Rose Letters": {
    link: "https://theflowerletters.com/products/the-audrey-rose-collection-monthly",
    image: "Audrey-Rose.jpg",
    displayName: "The Audrey Rose Letters: World War II Romance - Prepaid",
    price: "$99.99",
    originalPrice: "$155.40",
  },
  "The Lily Clara Letters": {
    link: "https://theflowerletters.com/products/the-lily-clara-collection-annual",
    image: "Lily-Clara.jpg",
    displayName: "The Lily Clara Letters: Western Romance Adventure - Prepaid",
    price: "$99.99",
    originalPrice: "$155.40",
  },
  "The Adelaide Magnoila Letters": {
    link: "https://theflowerletters.com/products/the-adelaide-magnolia-collection-annual",
    image: "Adelaide-Magnolia.jpg",
    displayName: "The Adelaide Magnolia Letters: Regency Romance - Prepaid",
    price: "$99.99",
    originalPrice: "$155.40",
  },
  "The Norah Aven Chronicles": {
    link: "https://theflowerletters.com/products/the-norah-aven-chronicles",
    image: "Norah-Aven.jpg",
    displayName: "The Norah Aven Chronicles: Fantasy Adventure - Prepaid",
    price: "$99.99",
    originalPrice: "$155.40",
  },
  "The Orchid Mae Letters": {
    link: "https://theflowerletters.com/products/the-orchid-mae-letters",
    image: "Orchid-Mae.jpg",
    displayName: "The Orchid Mae Letters: Archeology Adventure - Prepaid",
    price: "$123.95",
    originalPrice: "$155.40",
  },
};

const questions = [
  {
    question: "Which era best suits you?",
    options: [
      { text: "WW2", products: ["The Audrey Rose Letters"] },
      { text: "Wild West", products: ["The Lily Clara Letters"] },
      { text: "Regency", products: ["The Adelaide Magnoila Letters"] },
      { text: "Modern Day", products: ["The Norah Aven Chronicles"] },
      { text: "1900’s exploration", products: ["The Orchid Mae Letters"] },
    ],
    pointValue: 2,
  },
  {
    question: "Which genre most appeals to you?",
    options: [
      {
        text: "Romance",
        products: [
          "The Adelaide Magnoila Letters",
          "The Lily Clara Letters",
          "The Audrey Rose Letters",
        ],
      },
      {
        text: "History",
        products: ["The Audrey Rose Letters", "The Lily Clara Letters"],
      },
      {
        text: "Mystery",
        products: ["The Lily Clara Letters", "The Orchid Mae Letters"],
      },
      {
        text: "Adventure",
        products: ["The Norah Aven Chronicles", "The Lily Clara Letters"],
      },
      { text: "Fantasy", products: ["The Norah Aven Chronicles"] },
    ],
    pointValue: 1,
  },
  {
    question: "What type of character do you most relate to?",
    options: [
      {
        text: "Independent",
        products: ["The Lily Clara Letters", "The Orchid Mae Letters"],
      },
      { text: "Stressed", products: ["The Norah Aven Chronicles"] },
      { text: "Intelligent", products: ["The Audrey Rose Letters"] },
      {
        text: "Strong-willed",
        products: ["The Lily Clara Letters", "The Orchid Mae Letters"],
      },
      { text: "Refined", products: ["The Adelaide Magnoila Letters"] },
    ],
    pointValue: 1,
  },
  {
    question: "Which of these flowers is your favorite?",
    options: [
      { text: "Orchid", products: ["The Orchid Mae Letters"] },
      { text: "Aven", products: ["The Norah Aven Chronicles"] },
      { text: "Lily", products: ["The Lily Clara Letters"] },
      { text: "Magnolia", products: ["The Adelaide Magnoila Letters"] },
      { text: "Rose", products: ["The Audrey Rose Letters"] },
    ],
    pointValue: 1,
  },
  {
    question: "Which hobby do you enjoy the most?",
    options: [
      { text: "Embroidery", products: ["The Lily Clara Letters"] },
      {
        text: "Decoding secret messages",
        products: ["The Audrey Rose Letters", "The Norah Aven Chronicles"],
      },
      { text: "Knitting", products: ["The Audrey Rose Letters"] },
      {
        text: "Baking",
        products: ["The Audrey Rose Letters", "The Lily Clara Letters"],
      },
      {
        text: "Board games",
        products: [
          "The Adelaide Magnoila Letters",
          "The Norah Aven Chronicles",
        ],
      },
    ],
    pointValue: 1,
  },
  {
    question: "Which aspect of history intrigues you most?",
    options: [
      { text: "Archaeological Digs", products: ["The Orchid Mae Letters"] },
      { text: "War", products: ["The Audrey Rose Letters"] },
      { text: "Royalty/Nobility", products: ["The Adelaide Magnoila Letters"] },
      { text: "Myths", products: ["The Norah Aven Chronicles"] },
      { text: "Treasure Hunts", products: ["The Orchid Mae Letters"] },
    ],
    pointValue: 2,
  },
];

function showStep(step) {
  const steps = quizDemo.getElementsByClassName("quizdemo-sec");
  for (let i = 0; i < steps.length; i++) {
    if (steps[i].dataset.step == step) {
      steps[i].style.display = "block";
    } else {
      steps[i].style.display = "none";
    }
  }

  updateProgressBar(step);
  toggleNextButton(step);
  
  if (step === 1) {
    prevBtn.style.display = "none";
  }else if (step === 2) {
    prevBtn.style.display = "none";
  } else {
    prevBtn.style.display = "inline-block";
  }

  if (step === steps.length) {
    nextBtn.style.display = "none";
    finelBtn.style.display = "inline-block";
  } else {
    nextBtn.style.display = "none";
    finelBtn.style.display = "none";
  }

  // Update the readonly attribute for the next button
  const nextStepButton = document.querySelector(".nextstepdisableanimation");
  if (nextStepButton) {
    if (step === steps.length) {
      nextStepButton.setAttribute("readonly", "true");
    } else {
      nextStepButton.removeAttribute("readonly");
    }
  }
}

function updateProgressBar(step) {
  const totalSteps = quizDemo.getElementsByClassName("quizdemo-sec").length;
  const percent = Math.round(((step - 1) / (totalSteps - 1)) * 100);
  progressBar.style.width = percent + "%";
  progressBar.textContent = percent + "% complete";
}

function prevStep() {
  if (currentStep > 1) {
    subtractPoints(currentStep - 1);
    currentStep--;
    showStep(currentStep);
  }
}

function nextStep() {
  if (currentStep < quizDemo.getElementsByClassName("quizdemo-sec").length) {
    currentStep++;
    showStep(currentStep);
  }
}

function resetToFirstStep() {
  currentStep = 1;
  resetPoints();
  showStep(currentStep);
}

function recordAnswer(questionIndex, optionIndex) {
  const selectedOption = questions[questionIndex].options[optionIndex];
  const pointValue = questions[questionIndex].pointValue;
  const questionText = questions[questionIndex].question;
  selectedOption.products.forEach((product) => {
    points[product] += pointValue;
  });

  // Enable the next button if an option is selected
  toggleNextButton(currentStep);
  trackQuestionAnswered(questionText);
}

function subtractPoints(questionIndex) {
  const options = document.querySelectorAll(
    `.quizdemo-sec[data-step="${questionIndex + 1}"] input[type="radio"]`
  );
  options.forEach((option) => {
    if (option.checked) {
      const optionIndex = Array.prototype.indexOf.call(
        option.parentElement.children,
        option
      );
      const selectedOption = questions[questionIndex].options[optionIndex];
      const pointValue = questions[questionIndex].pointValue;
      selectedOption.products.forEach((product) => {
        points[product] -= pointValue;
      });
    }
  });
}

function calculateResult() {
  let maxPoints = 0;
  let recommendedProduct = "";

  for (const product in points) {
    if (points[product] > maxPoints) {
      maxPoints = points[product];
      recommendedProduct = product;
    }
  }

  displayResult(recommendedProduct);
}


function displayResult(product) {
  const productInfo = productLinks[product];
  productCard.innerHTML = `
    <img class="product-image-dynamically" data-filename="${productInfo.image}" alt="${productInfo.displayName}">
    <h4>${productInfo.displayName}</h4>
    <p>${productInfo.price} <span class="del">${productInfo.originalPrice}</span></p>
    <a href="${productInfo.link}" class="btn-blue" onclick="trackStoryRedirection('${productInfo.displayName}')">See Story</a>`;
  trackRecommendedStory(productInfo.displayName);
}



/* new code */

function resetPoints() {
  for (const product in points) {
    points[product] = 0;
  }
}

function toggleNextButton(step) {
  const stepElement = quizDemo.querySelector(`.quizdemo-sec[data-step="${step}"]`);
  const options = stepElement.querySelectorAll('input[type="radio"]');
  let isSelected = false;

  options.forEach((option) => {
    if (option.checked) {
      isSelected = true;
    }
  });

  nextBtn.disabled = !isSelected;
}

document.addEventListener("DOMContentLoaded", () => {
  const options = document.querySelectorAll("input[type='radio']");
  options.forEach((option, index) => {
    option.addEventListener("click", () => {
      const questionIndex = Math.floor(index / 5);
      const optionIndex = index % 5;
      recordAnswer(questionIndex, optionIndex);

      if (
        currentStep === quizDemo.getElementsByClassName("quizdemo-sec").length
      ) {
        calculateResult();
      }
    });
  });

  showStep(currentStep);
});